import { readImpersonation, returnToAdmin } from '../lib/impersonation';

export function ImpersonationBanner({ onExit }: { onExit: () => void }) {
  const meta = readImpersonation();
  if (!meta) return null;
  return (
    <div className="flex shrink-0 items-center justify-between gap-3 bg-amber-400/15 px-3 py-1.5 text-[12px] text-amber-100">
      <span className="min-w-0 truncate">
        Viewing as <span className="font-semibold text-white">{meta.label}</span>
        {meta.actor ? <span className="text-amber-200/80"> · {meta.actor}</span> : null}
      </span>
      <button
        type="button"
        className="shrink-0 rounded-md px-2 py-0.5 font-medium text-amber-100 ring-1 ring-amber-200/30 hover:bg-amber-400/20"
        onClick={() => returnToAdmin(onExit)}
      >
        Back to admin
      </button>
    </div>
  );
}
